<template>
  <v-dialog v-model="showDialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="text-primary">
        Confirmar Firma
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text>
        <p class="mb-4">
          Por favor ingrese su contraseña para confirmar la firma de la entrega.
        </p>
        
        <v-form ref="form" @submit.prevent="confirmPassword">
          <v-text-field
            v-model="password"
            label="Contraseña"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :error-messages="errorMessage"
            @input="errorMessage = ''"
            outlined
            autocomplete="current-password"
            :rules="passwordRules"
          ></v-text-field>
        </v-form>
        
        <v-alert
          v-if="showWarning"
          type="warning"
          dense
          outlined
          class="mt-2"
        >
          Firmar una entrega es una acción importante que no puede ser revertida.
        </v-alert>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="grey darken-1"
          @click="$emit('cancel')"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="#2D4B95"
          dark
          :loading="loading"
          @click="confirmPassword"
        >
          Confirmar Firma
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PasswordConfirmationModal',
  
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showWarning: {
      type: Boolean,
      default: true
    }
  },
  
  data() {
    return {
      password: '',
      showPassword: false,
      errorMessage: '',
      passwordRules: [
        v => !!v || 'La contraseña es requerida'
      ]
    };
  },
  
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  
  watch: {
    show(newValue) {
      if (newValue) {
        this.password = '';
        this.errorMessage = '';
      }
    }
  },
  
  methods: {
    confirmPassword() {
      if (!this.$refs.form.validate()) {
        return;
      }
      
      this.$emit('confirm', this.password);
    }
  }
};
</script>

<style scoped>
.text-primary {
  color: #2D4B95;
}
</style>